import React from 'react'
import styled from '@emotion/styled'
import { Container } from 'shared/layout/Container'
import { colors, mediaQueriesByDevice } from 'parameters/index'
import { Badge, BadgeWrapper } from 'experiences/explore/loans/components/Badge'
import { LowRateIcon } from 'experiences/explore/loans/components/icons'
import { NewLoanSearchWidget } from './NewLoanSearchWidget'
import { BlockComponent } from 'lib'

interface Props {
	badgeText: string
	title: string
}

export const Hero: BlockComponent<Props> = ({ badgeText, title }) => {
	return (
		<HeroWrapper>
			<HeroContainer>
				<Badge text={badgeText} icon={<LowRateIcon />} />
				<HeroTitle>{title}</HeroTitle>
				<NewLoanSearchWidget />
			</HeroContainer>
		</HeroWrapper>
	)
}

const HeroWrapper = styled.div`
	background: radial-gradient(1654.63% 19491.51% at 67.2% 47.66%, #592b86 0%, #3b0d68 100%);
	background-size: cover;
	background-position: right center;
	height: 470px;
`

const HeroContainer = styled(Container)`
	padding-bottom: 0;
	background-image: url('/images/illustrations/loans-hero.svg');
	background-repeat: no-repeat;
	background-position: 80% 40px;
	height: 100%;
	position: relative;

	${BadgeWrapper} {
		margin-top: 12px;
	}

	${mediaQueriesByDevice.laptop} {
		background-position: 90% 40px;
	}

	${mediaQueriesByDevice.mobile} {
		background-position: 200% 40px;
	}

	${mediaQueriesByDevice.mobilePortrait} {
		background-position: 250px 40px;
	}
`

const HeroTitle = styled.h1`
	max-width: 477px;
	line-height: 1.45;
	margin-top: 48px;
	margin-bottom: 120px;
	color: ${colors.white};

	${mediaQueriesByDevice.mobile} {
		max-width: 253px;
	}
`
